import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import OnboardingLayout from '../../components/onboarding/OnboardingLayout';
import OptionButton from '../../components/onboarding/OptionButton';
import { useOnboarding } from '../../contexts/OnboardingContext';

const OnboardingStep3 = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { responses, updateResponses, markStepCompleted } = useOnboarding();
  const [selected, setSelected] = useState<string[]>(responses.lifeCompanions || []);
  const progress = (3 / 14) * 100;

  const options = [
    { value: 'sendiri', label: t('onboarding.step3.options.sendiri'), emoji: '😋' },
    { value: 'suami', label: t('onboarding.step3.options.suami'), emoji: '🤵‍♂️' },
    { value: 'istri', label: t('onboarding.step3.options.istri'), emoji: '👰‍♀️' },
    { value: 'orang_tua', label: t('onboarding.step3.options.orang_tua'), emoji: '🤗' },
    { value: 'anak', label: t('onboarding.step3.options.anak'), emoji: '👶' },
    { value: 'peliharaan', label: t('onboarding.step3.options.peliharaan'), emoji: '🐾' },
  ];

  const toggleOption = (value: string) => {
    setSelected(prev =>
      prev.includes(value)
        ? prev.filter(v => v !== value)
        : [...prev, value]
    );
  };

  const handleNext = () => {
    updateResponses('lifeCompanions', selected);
    markStepCompleted(3);
    navigate('/onboarding/step-4');
  };

  return (
    <OnboardingLayout progress={progress}>
      <div className="bg-white border-4 border-[#077f5d] p-8" style={{ boxShadow: '6px 6px 0 #077f5d' }}>
        <div className="mb-6">
          <h2
            className="text-center text-[#077f5d] mb-4 uppercase"
            style={{ fontFamily: "'Press Start 2P'", lineHeight: '1.3' }}
          >
            {t('onboarding.step3.title')}
          </h2>
        </div>

        <div className="space-y-3 mb-8">
          {options.map(option => (
            <OptionButton
              key={option.value}
              label={option.label}
              emoji={option.emoji}
              selected={selected.includes(option.value)}
              onClick={() => toggleOption(option.value)}
            />
          ))}
        </div>

        <button
          type="button"
          onClick={handleNext}
          disabled={selected.length === 0}
          className="w-full bg-[#3cbe8c] text-white px-8 py-4 border-2 border-[#077f5d] font-bold uppercase   hover:-translate-y-[2px] active:translate-y-[2px] active:shadow-none transition-all duration-75 disabled:opacity-50 disabled:cursor-not-allowed disabled:translate-y-0"
          style={{
            fontFamily: "'Press Start 2P', monospace",
            fontSize: '12px',
            boxShadow: '6px 6px 0 #077f5d'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = '4px 4px 0 #077f5d';
            e.currentTarget.style.transform = 'translate(-2px, -2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = '6px 6px 0 #077f5d';
            e.currentTarget.style.transform = 'translate(0, 0)';
          }}
        >
          {t('onboarding.step3.next')}
        </button>
      </div>
    </OnboardingLayout>
  );
};

export default OnboardingStep3;
